import type { RaffleTier } from "./types";

// Допускаются выбранный статус и все выше — нужен самый младший.
export const getMinTier = (tiers: RaffleTier[]): RaffleTier | undefined =>
  tiers.reduce<RaffleTier | undefined>(
    (min, tier) => (!min || tier.sort_order < min.sort_order ? tier : min),
    undefined,
  );
